import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EnvService } from 'src/services/env.service';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-signup-header',
    templateUrl: './signup-header.component.html',
    styleUrls: ['./signup-header.component.less'],
    imports: [NgIf]
})
export class SignupHeaderComponent implements OnInit {

    accountTypesUsingCxLogin = ['agency', 'educationProvider'];

    loginUsesCx = false;
    isSsoEnabled = false;

    constructor(private env: EnvService,
                private router: Router,
                private route: ActivatedRoute,
                private window: Window) {
    }

    ngOnInit(): void {
        const accountType = this.route.snapshot.queryParams.accountType;
        this.loginUsesCx = this.accountTypesUsingCxLogin.includes(accountType);
        this.isSsoEnabled = this.route.snapshot.queryParams.ssoEnabled === 'true';
    }

    goToSignIn() {
        if (this.loginUsesCx) {
            this.window.open(this.env.SIRCON_URL + '/login.jsp', '_self');
        } else {
            this.router.navigate(['/login']);
        }
    }
}
